<template>
    <div class="main-wrapper">
        <el-breadcrumb separator-class="el-icon-arrow-right" class="admin-el-breadcrumb">
            <el-breadcrumb-item :to="{ path: '/schoolAdmin/education/TeacherAdmin'}">教师管理</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="select-left">
            <div class="search-btn">
                <el-input placeholder="请输入内容" v-model="searchInput" @keyup.enter.native="changeSearch" size="medium">
                    <el-button slot="append" icon="el-icon-search" @click="changeSearch" size="medium"></el-button>
                </el-input>
            </div>
            <div class="search-btn">
                <el-button class="btn-yellow" @click="createTeacher" size="medium"><i class="el-icon-plus"></i> 创建教师</el-button>
            </div>
        </div>
        <div class="teacher-content">
            <el-table :data="teacherListTable" class="subject-table" style="width: 100%; flex: 1" height="1%"  size="medium"
                      header-cell-class-name="table-header-cell"
                      :header-cell-style="{fontWeight: 'normal', color: '#333', background: '#eee',height:'50px'}"
                      :cell-style="{fontSize: '12px',color: '#333',height: '64px'}">
                <el-table-column prop="user_name" label="教师名称" align="left" class-name="123">
                    <template slot-scope="scope" >
                        <span class="teacher-name">{{scope.row.user_name}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="c_name" label="专业分类" align="center" ></el-table-column>
                <el-table-column prop="user_account" label="账号" align="center" ></el-table-column>
                <el-table-column label="操作" align="center" width="200">
                    <template slot-scope="scope" >
                        <el-button size="small" type="text"  class="teacher-btn-black" @click="editPassword(scope.row)">修改密码</el-button>
                        <el-button size="small" type="text"  class="teacher-btn-blue" @click="editTeacher(scope.row)">编辑</el-button>
                        <el-button size="small" type="text"  class="teacher-btn-red" @click="deleteTeacher(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    class="pages-center" style="margin-bottom: 10px"
                    :current-page="teacherPages.currentPageNum"
                    :page-size="teacherPages.eachPageNum"
                    layout="prev, pager, next, jumper"
                    :total="teacherPages.total"
                    @current-change="teacherPagesCurrentChange">
            </el-pagination>
        </div>
        <!--创建/编辑弹窗-->
        <el-dialog :title="teacherTitleType" :visible.sync="dialogAddTeacher" custom-class="centerDialog" width="472px" @close="resetForm()" :close-on-click-modal="false">
            <el-form :model="addTeacherForm" ref="addTeacherForm" :rules="rules" label-position="center" class="info-form">
                <el-form-item label="名称" :label-width="formLabelWidth" prop="user_name">
                    <el-input v-model="addTeacherForm.user_name"  autocomplete="off" placeholder="1-20字符" style="width: 80%"></el-input>
                </el-form-item>
                <el-form-item label="账号" :label-width="formLabelWidth" prop="user_account">
                    <el-input v-model="addTeacherForm.user_account" autocomplete="off" placeholder="1-20字符" style="width: 80%"></el-input>
                </el-form-item>
                <el-form-item v-if="teacherTitleType==='创建教师'" label="密码" :label-width="formLabelWidth" prop="user_password">
                    <el-input v-model="addTeacherForm.user_password" autocomplete="off" type="password" placeholder="6-16字符" style="width: 80%"></el-input>
                </el-form-item>
                <el-form-item label="选择分类" :label-width="formLabelWidth" prop="rc_name">
                    <el-select v-model="addTeacherForm.rc_name" placeholder="请选择分类"  @change="teacherSelect($event)" style="width: 80%;" >
                        <el-option
                                v-for="item in classList"
                                :key="item.rc_id"
                                :label="item.rc_name"
                                :value="item.rc_id">
                        </el-option>
                    </el-select>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="medium" @click="dialogAddTeacher = false">取 消</el-button>
                <el-button size="medium" class="btn-yellow" @click="addToForm('addTeacherForm')">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="修改密码" :visible.sync="dialogPassword" custom-class="centerDialog" width="472px" @close="resetForm()" :close-on-click-modal="false">
            <el-form :model="addTeacherForm" ref="addTeacherForm" :rules="rules" label-position="center" class="info-form">
                <el-form-item label="密码" :label-width="formLabelWidth" prop="user_password">
                    <el-input type="password" v-model="addTeacherForm.user_password" autocomplete="off" placeholder="1-6字符" style="width: 80%"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="medium" @click="dialogPassword = false">取 消</el-button>
                <el-button size="medium" class="btn-yellow" @click="addToPassword('addTeacherForm')">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "TeacherAdmin",
        data(){
            return{
                searchInput:'',//搜索内容
                // keyObj: {
                //     label: 'rc_name',
                //     value: 'rc_id',
                //     children: 'children'
                // },
                classList: [],
                teacherListTable:[],//教师列表
                teacherTitleType:'',//弹窗文字类型
                dialogAddTeacher:false,//弹窗
                dialogPassword: false,
                //教师表单数据
                addTeacherForm: {
                    id:'',
                    user_name:'',
                    user_account:'',
                    user_password:'',
                    rc_id:'',
                    rc_name:'',
                },
                rules: {
                    user_name: [
                        { required: true, message: '请输入教师名称', trigger: 'blur' },
                        { min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' }
                    ],
                    user_account: [
                        { required: true, message: '请输入账号', trigger: 'blur' },
                        { min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' }
                    ],
                    user_password: [
                        { required: true, message: '请输入长度在 6 到 6 个字符密码', trigger: 'blur' },
                        { min: 6, max: 16, message: '长度在 6 到 16 个字符', trigger: 'blur' },
                    ],
                    rc_name: [
                        { required: true, message: '请选择分类', trigger: 'change' }
                    ]
                },
                formLabelWidth: '80px',
                //编辑/保存
                distinguishBtn: '',
                //分页
                teacherPages: {
                    currentPageNum: 1,
                    eachPageNum: 10,
                    total: 0,
                },
            }
        },
        created() {
            this.getSpecializedList();
            this.getTeacherList();
        },
        methods:{
            //创建教师
            createTeacher() {
                this.dialogAddTeacher = !this.dialogAddTeacher;
                this.teacherTitleType = '创建教师';
                this.distinguishBtn = 'add';
            },
            //编辑教师
            editTeacher(row) {
                this.dialogAddTeacher = !this.dialogAddTeacher;
                this.teacherTitleType = '编辑教师';
                this.distinguishBtn = 'edit';
                this.addTeacherForm.user_name = row.user_name;
                this.addTeacherForm.user_account = row.user_account;
                this.$set(this.addTeacherForm,'user_id',row.user_id);
                this.$http.axiosGetBy(this.$api.getTeacher, {user_id: row.user_id}, (res) => {
                    if(res.code === 200){
                        this.addTeacherForm.rc_id = res.data.rc_id;
                        this.addTeacherForm.rc_name = res.data.rc_name;
                    }else {
                        this.$message({
                            type: 'error',
                            message: res.msg,
                            duration: 1000
                        });
                    }
                })
            },
            //确定
            addToForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if (this.distinguishBtn === 'add') {
                            let formData = new FormData();
                            formData.append('user_name', this.addTeacherForm.user_name);
                            formData.append('user_account', this.addTeacherForm.user_account);
                            formData.append('user_password', this.addTeacherForm.user_password);
                            formData.append('rc_name', this.addTeacherForm.rc_name);
                            formData.append('rc_id', this.addTeacherForm.rc_id);
                            this.$http.axiosPost(this.$api.addTeacher, formData,(res) => {
                                if (res.code === 200) {
                                    this.$message({
                                        type: 'success',
                                        message: res.msg,
                                        duration: 1000,
                                        onClose: () => {
                                            this.dialogAddTeacher = !this.dialogAddTeacher;
                                            this.getTeacherList()
                                            this.resetForm();
                                        }
                                    });
                                } else {
                                    this.$message({
                                        type: 'error',
                                        message: res.msg,
                                        duration: 1000
                                    });
                                }
                            }, (err) => {
                                console.log(err)
                            })
                        }
                        else if (this.distinguishBtn === 'edit') {
                            let formData = new FormData();
                            formData.append('user_id', this.addTeacherForm.user_id);
                            formData.append('user_name', this.addTeacherForm.user_name);
                            formData.append('user_account', this.addTeacherForm.user_account);
                            formData.append('rc_name', this.addTeacherForm.rc_name);
                            formData.append('rc_id', this.addTeacherForm.rc_id);
                            this.$http.axiosPost(this.$api.editTeacher, formData,(res) => {
                                if (res.code === 200) {
                                    this.$message({
                                        type: 'success',
                                        message: res.msg,
                                        duration: 1000,
                                        onClose: () => {
                                            this.dialogAddTeacher = !this.dialogAddTeacher;
                                            this.getTeacherList()
                                            this.resetForm();
                                        }
                                    });
                                } else {
                                    this.$message({
                                        type: 'error',
                                        message: res.msg,
                                        duration: 1000
                                    });
                                }
                            }, (err) => {
                                console.log(err)
                            })
                        }
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            // 选择分类获取分类列表
            getSpecializedList() {
                this.$http.axiosGet(this.$api.getReasourceFirst,(res) => {
                    if (res.code === 200) {
                        this.classList = res.data;
                    }
                })
            },
            //选择专业分类
            teacherSelect(e){
                this.addTeacherForm.rc_id = e;
            },
            // 获取教师列表
            getTeacherList() {
                let param = {
                    page: this.teacherPages.currentPageNum,
                    limit: this.teacherPages.eachPageNum
                };
                if (this.searchInput) {
                    param.search = this.searchInput
                    param.page = 1
                }
                this.$http.axiosGetBy(this.$api.teacherList,param,(res) => {
                    if (res.code === 200) {
                        this.teacherListTable = res.data.data;
                        this.teacherPages.total = res.data.total;
                    }
                }, (err) => {
                    console.log(err)
                })
            },
            //修改密码
            addToPassword(formName){
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        let param = {
                            user_password: this.addTeacherForm.user_password,
                            user_id: this.addTeacherForm.user_id
                        };
                        this.$http.axiosGetBy(this.$api.resetPwdTeacher, param, (res) => {
                            if (res.code === 200) {
                                this.$message({
                                    type: 'success',
                                    message: res.msg,
                                    duration: 1000,
                                });
                                this.dialogPassword = !this.dialogPassword;
                            } else {
                                this.$message({
                                    type: 'error',
                                    message: res.msg,
                                    duration: 1000
                                });
                            }
                        }, (err) => {
                            console.log(err)
                        })
                    }
                })
            },
            //修改密码按钮
            editPassword(row) {
                this.dialogPassword = !this.dialogPassword;
                this.addTeacherForm.user_id = row.user_id;
                this.addTeacherForm.admin_password = row.user_password;
            },
            //删除
            deleteTeacher(row) {
                this.$confirm('是否删除该教师，删除完将无法恢复', '提示消息', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    confirmButtonClass: 'btn-yellow',
                    type: 'warning',
                }).then(() => {
                    this.$http.axiosGetBy(this.$api.delTeacher, {user_id: row.user_id},(res) => {
                        if (res.code === 200) {
                            this.$message.success(res.msg);
                            this.getTeacherList()
                        } else {
                            this.$message.warning(res.msg)
                            this.getTeacherList()
                        }
                    }, (err) => {
                        console.log(err)
                    })
                }).catch(() => {
                    this.$message.info('已取消删除');
                })
            },
            //重置表单
            resetForm() {
                this.$refs.addTeacherForm.resetFields();
                this.$set(this.addTeacherForm,'name','');
                this.$set(this.addTeacherForm,'account','');
                this.$set(this.addTeacherForm,'password','');
                this.$set(this.addTeacherForm,'rc_name','');
                this.$set(this.addTeacherForm,'rc_id','');
                delete this.addTeacherForm.user_id

                // this.addTeacherForm = {
                //     name:'',
                //     account:'',
                //     password:'',
                //     rc_name: '',
                //     rc_id:''
                // }
            },
            // 搜索
            changeSearch(){
                this.getTeacherList()
            },
            //分页
            teacherPagesCurrentChange(val) {
                this.teacherPages.currentPageNum = val;
                this.getTeacherList()
            },
        }
    }
</script>

<style scoped lang="scss">
    .select-left {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        padding: 12px 40px;
        .search-btn {
            margin-left: 20px;
            /deep/ .el-input-group__append,
            /deep/ .el-input-group__prepend {
                background: #FFD500;
                border-color: #FFD500;
                color: #333;
                font-size: 16px;
                .el-button--default {
                    i {
                        font-weight: bold;
                    }
                }
            }
        }
    }
    .teacher-content {
        flex: 1;
        display: flex;
        flex-direction: column;
        height: calc(100% - 80px);
        .teacher-name{
            padding-left: 30px;
        }
        .subject-table{
            /deep/ .table-header-cell {
                &:first-child {
                    padding-left: 30px;
                }
            }
        }
    }
    .dialog-footer{
        display: flex;
        justify-content: center;
    }
</style>